/** Keycloak client roles for the LIKS platform client. */
export const KEYCLOAK_CLIENT_ROLES = ['LAC_ADMIN', 'ADMIN', 'MEMBER'] as const;

export type KeycloakClientRole = (typeof KEYCLOAK_CLIENT_ROLES)[number];

export const DEFAULT_KEYCLOAK_CLIENT_ROLE: KeycloakClientRole = 'MEMBER';

export function isKeycloakClientRole(
  value: string,
): value is KeycloakClientRole {
  return (KEYCLOAK_CLIENT_ROLES as readonly string[]).includes(value);
}

export function hasKeycloakClientRole(
  roles: readonly string[] | null | undefined,
  role: KeycloakClientRole,
): boolean {
  return roles?.includes(role) ?? false;
}

/** Pick the highest-privilege known client role from an assigned role list. */
export function resolveKeycloakClientRoleFromNames(
  roleNames: string[] | null | undefined,
): KeycloakClientRole {
  const assigned = new Set(roleNames ?? []);
  for (const role of KEYCLOAK_CLIENT_ROLES) {
    if (assigned.has(role)) {
      return role;
    }
  }
  return DEFAULT_KEYCLOAK_CLIENT_ROLE;
}
